// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_fV","galleryThumbnail_active":"c-q_fW","galleryThumbnail__image":"c-q_fX"};